module.exports = __webpack_public_path__ + "img/yuliya_koroleva-min.e381dd52.jpg";